<!--
 * @Author: 张怀宇
 * @Date: 2021-01-07 14:01:21
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-05-21 14:45:50
-->
<template>
  <div>
    <BreadCrumb class="bread" :breads="['设备管理', '盘点记录']"></BreadCrumb>
    <div class="wrap">
      <div class="header">
        <span class="nameFt">盘点记录</span>
      </div>
    </div>
    <div class="submit-form">
      <el-form :model="search" :inline="true" size="small" label-width="80px">
        <div class="submit-form__search">
          <el-form-item label="时间范围">
            <!-- <el-date-picker
              v-model="time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker> -->
            <el-date-picker
                v-model="time"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                :default-time="['00:00:00', '23:59:59']"
                clearable
              ></el-date-picker>
          </el-form-item>
          <el-form-item label="机器编号">
            <el-input size="small" v-model="search.hard_number"></el-input>
            <!-- <el-input
              size="small"
              v-model="search.hard_number"
              suffix-icon="el-icon-search"
              readonly
              @focus="setDialogSearchItem('hard_number')"
            ></el-input> -->
          </el-form-item>
          <el-form-item label="盘点人">
            <el-input
              v-model="search.name"
              readonly
              suffix-icon="el-icon-search"
              @focus="setDialogSearchItem('name')"
            ></el-input>
          </el-form-item>
           <el-form-item label="线路">
            <el-input
              v-model="search.line"
              readonly
              suffix-icon="el-icon-search"
              @focus="setDialogSearchItem('line')"
            ></el-input>
          </el-form-item>
        </div>
        <div class="submit-form__operate">
          <el-form-item>
            <el-button
              class="queryBtn"
              size="small"
              type="primary"
              @click="searchForm"
              >查询</el-button
            >
            <el-button
              class="queryBtn"
              size="small"
              type="primary"
              @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="operate-con">
      <el-button size="small" @click="exportExcel">导出csv格式</el-button>
       <el-button size="small" @click="exportExcel2" type="warning">导出excel格式</el-button>
    </div>
    <div class="table-con">
      <el-table :data="tableList" stripe>
         <el-table-column type="index" label="序号" align="center" :index="indexMethod"></el-table-column>
          <el-table-column label="盘点单号" align="center" prop="business_no"></el-table-column>
          <el-table-column label="机器编号" align="center" prop="hard_number"></el-table-column>
          <el-table-column label="线路" align="center" prop="line_name"></el-table-column>
          <el-table-column label="点位" align="center" prop="point_name"></el-table-column>
          <el-table-column label="类型" align="center" prop="business"></el-table-column>
          <el-table-column label="盘点人" align="center" prop="sock_inventory_user"></el-table-column>
          <el-table-column label="盘货时间" align="center" prop="created_at"></el-table-column>
          <el-table-column label="盘点比" align="center" prop="inventory_ratio">
            <div slot-scope="scope">
              {{scope.row.inventory_ratio}}%
            </div>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <div slot-scope="scope">
              <el-button size="small" @click="openView(scope.row.inventory_id)">查看</el-button>
              <el-button size="small" type="primary" @click="openVideo(scope.row)">查看视频</el-button>
            </div>
          </el-table-column>
      </el-table>
    </div>
    <simple-find-dialog
      :show="dialogVisible"
      @close="closeSimpleDialog"
      :dialogData="dialogData"
      :width="'500px'"
    ></simple-find-dialog>
    <div class="paginationWrap">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :current-page="pageNum"
          :layout="pageLayout"
          :total="total"
        ></el-pagination>
      </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import listMixin from "@/mixins/list";
import apis from "@/config/apis";
import SimpleFindDialog from "@/components/SimpleFindDialog";
import { dateFormat } from "@/plugins/util";
import { download } from "@/plugins/util";
export default {
  components: {
    BreadCrumb,
    SimpleFindDialog,
  },
  mixins: [listMixin],
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick: function (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick: function (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick: function (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      loading: false,
      search: {
        start_time: "",
        end_time: "",
      },
      dialogVisible: false,
      nowDialog: "",
      dialogData: {},
    };
  },
  created() {
    this.search = Object.assign(this.search, this.$route.query);
    // this.time = this.defaultDate();
    this.getData();
  },
  computed: {
    // time: {
    //   get() {

    //     return [this.search.start_time, this.search.end_time];
    //   },
    //   set(value) {
    //     if (value && value.length > 0) {
      //let a = a let b = b;
    //       this.search.start_time = dateFormat("yyyy-MM-dd", value[0]);
    //       this.search.end_time = dateFormat("yyyy-MM-dd", value[1]);
    //     } else {
    //       this.search.start_time = "";
    //       this.search.end_time = "";
    //     }
    //   },
    // },
    time: {
      get() {
        return [this.search.start_time, this.search.end_time];
      },
      set(val) {
        if (val) {
          this.search.start_time = val[0];
          this.search.end_time = val[1];
        } else {
          this.search.start_time = "";
          this.search.end_time = "";
        }
      },
    },
  },
  methods: {
    //设置默认当天
    defaultDate() {
      let date = new Date();
      let year = date.getFullYear().toString();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString();
      let da =
        date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString();
      let timeStamp = year + "-" + month + "-" + da;
      return [timeStamp + " 00:00:00", timeStamp + " 23:59:59"];
    },
    searchForm() {
      this.search.page_index = 1;
      this.getData();
    },
    reset() {
      this.search = {
        start_time: "",
        end_time: "",
      };
      this.searchForm();
    },
    getData() {
      this.getTableData(apis.inventory_record, "post", this.search);
    },
    openVideo(item){
      window.open(item.video_path, "_blank");
    },
    setDialogSearchItem(type) {
      switch (type) {
        case "hard_number":
          this.dialogData = {
            searchItems: [
              {
                key: "hard_number",
                label: "机器编号",
              },
            ],
            searchTableItem: [
              {
                key: "name",
                name: "机器编号",
              },
            ],
            proxyLink: "split_bill_get_hard_number",
            proxyType: "get",
          };
          break;
        case "name":
          this.dialogData = {
            searchItems: [
              {
                key: "name",
                label: "盘点人",
              },
            ],
            searchTableItem: [
              {
                key: "rel_name",
                name: "盘点人",
              },
            ],
            proxyLink: "replenishList",
            proxyType: "get",
          };
          break;
          case "line":
          this.dialogData = {
            searchItems: [
              {
                key: "name",
                label: "线路",
              },
            ],
            searchTableItem: [
              {
                key: "name",
                name: "线路名称",
              },
            ],
            proxyLink: "terminal_line",
            proxyType: "get",
          };
          break;
      }
      this.dialogVisible = true;
      this.nowDialog = type;
    },
    closeSimpleDialog(data) {
      this.dialogVisible = false;
      switch (this.nowDialog) {
        case "hard_number":
          this.search.tid = data.id;
          this.search.hard_number = data.name;
          break;
        case "name":
          this.search.inventory_user_id = data.id;
          this.search.name = data.rel_name;
          break;
        case "line":
          this.search.line = data.name;
          this.search.line_id = data.id;
          break;
      }
    },
    openView(id){
      this.$router.push({
        name: "inventoryDetail",
        query: {
          id: id
        },
        params: this.$route.query
      })
    },
     // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: '导出下载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'

      });
      let _search = Object.assign(this.search, {
        export: true,
        export_type:'csv'
      });
      console.log(_search);
      download(
        this,
        apis.sock_inventory_export,
        "盘点记录表.csv",
        "get",
        _search
      ).then(()=>{
        loading.close()
      }).catch(()=>{
        loading.close()
        this.$message({
          message:'选择数据过多或网速较慢,下载超时，建议重新选择数据下载!',
          type: 'warning'
        })
      })
    },

      exportExcel2() {
         const loading = this.$loading({
        lock: true,
        text: '导出下载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'

      });
            let url = `${apis.sock_inventory_export}`;
            this.$axios
              .get(url, {
                params: Object.assign(this.search, { export: true, export_type:'xls' }),
                responseType: "arraybuffer",
              })
              .then((res) => {
                loading.close()
                let url = window.URL.createObjectURL(
                  new Blob([res.data], {
                    type: "application/vnd.ms-excel",
                  })
                );
                let link = document.createElement("a");
                link.style.display = "none";
                link.href = url;
                link.setAttribute("download", "盘点记录表" + ".xls");
                document.body.appendChild(link);
                link.click();
              });
        },
  },
};
</script>

<style>
</style>